export default "__VITE_ASSET__535db731__"